export default __webpack_public_path__ + "static/living_room-0b11b06e66e73d7ecabdc2c5d750ca10.png";